// @ts-check
import _ from 'lodash';
import { SPACES } from 'common/constants/sizes';
import { SUPPORTED_CHAT_TOOLS } from 'common/constants/constants';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { Flex, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import TeamNotificationsListHeaders from '../../ChatTools/TeamNotificationListHeaders';
import { LBButton } from '@linearb/buzz';

const TeamTopHeaders = ({
  currentTeam,
  currentTeamSettings,
  openSlackChannelModal,
  history
}) => {
  const { name } = currentTeam;
  const { slackChannel } = currentTeamSettings;

  return (
    <Flex direction='column'>
      <Text
        size='large'
        color='abbey'
        weight='500'
        pb={SPACES.small}
        textTransform='uppercase'
      >
        team slack channel
      </Text>
      <Flex direction='row' items='center'>
        <Text size='large' color='shuttleGray' pr={SPACES.small}>
          The team {name} is receiving notifications on Slack channel:
        </Text>
        <LBButton
          variant='outline'
          size='sm'
          onClick={() =>
            openSlackChannelModal(currentTeam, currentTeamSettings, true)
          }
        >
          #{_.get(slackChannel, 'name', null)}
          <Icon name='pencil' size='x-small' />
        </LBButton>
      </Flex>
      <Separator
        color={getColor('catskillWhite')}
        width='100%'
        height='1px'
        margin='2rem 0'
      />
      <TeamNotificationsListHeaders
        applicationName={SUPPORTED_CHAT_TOOLS.SLACK}
        history={history}
      />
    </Flex>
  );
};

export default TeamTopHeaders;
